import { htmlDecode } from "../../../../../utils/parse";
import { QuestionCard } from "./QuestionCard";

import { MediaWithDescription } from "../MediaWithDescription";
import { useMemo } from "react";
import { QuestionOptions } from "./Options";

export function AssertionReasoning({ index, question, attempt,mark, status, checkQuestion }) {

  const correctAnswer = useMemo(() => {
   const answer = question.correctAnswers["assertion-reasoning"] || {};
   const option = question.options.find(option => option.optionId === answer?.option);
   return {
    optionId:option?.optionId,
    content:`
    <span>Option:</span> ${option?.value}<br/>
    <span>Explanation:</span> ${answer.explanation}
   `
   }
  },[question.correctAnswers])

  const {explanation,file} = useMemo(() => {
   const {answer,file,optionId} = attempt?.answer?.["assertion-reasoning"] || {};
   const option = question.options.find(option => option.optionId === optionId);
   return {
    optionId:option?.optionId,
    explanation:answer,
    file,
    content:`
    <span>Option:</span> ${option?.value}<br/>
    <span>Explanation:</span> ${answer}
   `
   }
  },[question.correctAnswers])


  return (
    <QuestionCard
      index={index}
      question={question}
      attempt={attempt}
      status={status}
      mark={mark}
      checkQuestion={checkQuestion}
      correctAnswer={correctAnswer.content}
      studentAnswer={{
        text:explanation,
        file
      }}
    >
      <MediaWithDescription mediaUrl={question.images?.assertImg}>
        {question.description?.assertion}
      </MediaWithDescription>
      <MediaWithDescription mediaUrl={question.images?.reasonImg}>
        {question.description?.reasoning}
      </MediaWithDescription>
      <QuestionOptions
        options={question.options}
        status={attempt?.status}
        selectedOptionId={correctAnswer.optionId}
      />
    </QuestionCard>
  );
}